import { Layout, Login } from '@/views/account';

export default {
    path: '/account',
    component: Layout,
    children: [
        { path: 'login', component: Login }
    ]
};
